import { useQuery } from "@tanstack/react-query"
import { subscriptionQuery } from "../lib/subscriptionQuery"

export function useGetSubscription(...args: Parameters<typeof subscriptionQuery>) {
  return useQuery(subscriptionQuery(...args))
}
